import {API_RESOURCES, createApiReadAction, createApiUpdateAction} from '../../util/api';
import env from '../../util/env';
import {serviceURL} from '../../util/uiconstants';
import {
	SET_RISK_WCGW_SELECTED,
	SAVE_RISK_WCGW_SELECTION,
	GET_SCOT_BY_ID,
	UPDATE_SCOT,
	CREATE_SCOT,
	DELETE_SCOT,
	GET_ALL_SCOTS,
	GET_ENGAGEMENT_ALL_SCOTS,
	GET_SCOTS_BY_ENG,
	CLEAN_SCOT
} from '../actiontypes';
export const updateStoreForSelected = (scotId, resource) => {
	return {
		type: SET_RISK_WCGW_SELECTED,
		scotId: scotId,
		data: resource
	};
};

export const getAllScots = (engagementId, args, filters) => {
	return createApiReadAction(
		GET_ALL_SCOTS,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.SCOTS]: undefined
		},
		filters,
		args
	);
};

export const getEngagementAllScots = (engagementId, args, filters) => {
	return createApiReadAction(
		GET_ENGAGEMENT_ALL_SCOTS,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.SCOTS]: undefined
		},
		filters,
		args
	);
};

export const getScotById = (engagementId, scotId, filters, isManageScots = false) => {
	return createApiReadAction(
		GET_SCOT_BY_ID,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.SCOTS]: scotId
		},
		filters,
		{scotId, isManageScots}
	);
};

export const updateScot = (engagementId, scotId, data, actionProps) => {
	return createApiUpdateAction(
		UPDATE_SCOT,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.SCOTS]: scotId
		},
		data,
		undefined,
		{resolve: true, ...actionProps}
	);
};

export const getSCOTById = (engagementId, scotId, documentId, expand) => {
	let newExpand = '';

	if (expand) {
		if (expand.toLowerCase().includes('wcgwcontrol')) {
			newExpand = 'includeControl=true';
		}
		if (expand.toLowerCase().includes('wcgw')) {
			newExpand += '&includeWCGW=true';
		}
	}

	const url = `${env.getBaseURL(serviceURL, engagementId)}Scots/${scotId}?${newExpand}`;

	return {
		type: GET_SCOT_BY_ID,
		resolve: true,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};

export const saveRiskWcgwSelection = (url, resource) => {
	return {
		type: SAVE_RISK_WCGW_SELECTION,
		meta: {
			api: {
				url,
				method: 'PUT',
				data: resource
			}
		}
	};
};

export const deleteSCOT = (url, scotId, actionProps) => {
	return {
		type: DELETE_SCOT,
		...actionProps,
		meta: {
			api: {
				url,
				method: 'DELETE'
			}
		},
		scotId
	};
};

export const updateSCOT = (url, data) => {
	return {
		type: UPDATE_SCOT,
		meta: {
			api: {
				url,
				method: 'PUT',
				data: data
			}
		}
	};
};

export const createSCOT = (engagementId, data, actionProps) => {
	const url = `${env.getBaseURL(serviceURL, engagementId)}Scots`;
	return {
		type: CREATE_SCOT,
		...actionProps,
		meta: {
			api: {
				url,
				method: 'POST',
				data: data
			}
		},
		resolve: true
	};
};

export const getSCOTsByEngagament = (engagementId) => {
	const url = `${env.getBaseURL(
		serviceURL,
		engagementId
	)}Scots?filterControlType=1%2C2&includeControl=true&includeIT=true`;
	return {
		type: GET_SCOTS_BY_ENG,
		resolve: true,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};

export function cleanScot() {
	return {
		type: CLEAN_SCOT
	};
}
